/*eslint-disable*/
import { Field } from "Util/Query";

/**
 * BestSeller Query
 * @class BestSeller
 * @namespace Query/BestSeller
 */

export class BestSellerQuery {
    getQuery(brand) {
        return new Field("bestSeller")
            .addFieldList(this._getSliderFields())
            .setAlias("bestSeller");
    }

    _getSliderFields() {
        return [
            this._getSlidesField(),
            this._getSaleProductField(),       
            this._getNewProductField(),            
            this._getBottomBannerField()
        ];
    }

    _getSlideFields() {
        return ["url", "image", "id"];
    }

    _getProductFields() {
        return ["url", "image", "name", "id", "price", "original_price"];
    }

    _getBottomBannerFields() {
        return [
            'url',
            'image',
            'type'            
        ];
    }

    _getSlidesField() {
        return new Field("bestSellers").addFieldList(this._getSlideFields());
    }

    _getSaleProductField() {
        return new Field("saleProduct").addFieldList(this._getProductFields());
    }

    _getNewProductField() {
        return new Field("newProduct").addFieldList(this._getProductFields());
    }
    _getBottomBannerField() {
        return new Field("bottomBanner").addFieldList(
            this._getBottomBannerFields()
        );
    }
    _getBottomBannerField() {
        return new Field('bottomBanner')
            .addFieldList(this._getBottomBannerFields());
    }
}
export default new BestSellerQuery();
